function a({ dataset: t }) {
  return !["src", "srcset"].some((e) => e in t);
}
function u(t) {
  return (e, s) => {
    var o;
    for (const n of e) {
      if (!n.isIntersecting)
        continue;
      const r = n.target;
      s.unobserve(r), !a(r) && (f(r, t), (o = t == null ? void 0 : t.onLoaded) == null || o.call(t, r));
    }
  };
}
const c = "loading" in HTMLImageElement.prototype, g = !("onscroll" in window) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);
function h(t, e = document) {
  return typeof t == "string" ? [...e.querySelectorAll(t)] : t instanceof Element ? [t] : [...t];
}
function f(t, e) {
  const { useNativeLoading: s = !1 } = e, { dataset: o } = t, { src: n, srcset: r, sizes: i, poster: d } = o;
  n && (t.src = n, delete o.src), t instanceof HTMLVideoElement ? d && (t.poster = d, delete o.poster) : (t instanceof HTMLImageElement && s && c && t.loading !== "lazy" && (t.loading = "lazy"), r && (t.srcset = r, delete o.srcset, i && (t.sizes = i === "auto" ? `${t.offsetWidth}px` : i)));
}
class v {
  constructor(e = "[data-lazyload]", s = {}) {
    this.selector = e, this.options = s;
    const {
      root: o,
      rootMargin: n,
      threshold: r,
      useNativeLoading: i = !1
    } = this.options;
    (!i || !c) && (this.observer = new IntersectionObserver(u(this.options), {
      root: o,
      rootMargin: n,
      threshold: r
    }));
  }
  observe() {
    var r;
    const { root: e, onLoaded: s, useNativeLoading: o } = this.options, n = h(this.selector, e);
    for (const i of n)
      a(i) || (o && c || g ? (f(i, this.options), s == null || s(i)) : (r = this.observer) == null || r.observe(i));
  }
  triggerLoad(e) {
    var s, o;
    a(e) || (f(e, this.options), (o = (s = this.options) == null ? void 0 : s.onLoaded) == null || o.call(s, e));
  }
}
let l;
(l = document.currentScript) && l.hasAttribute("init") && new v().observe();
export {
  v as default
};
